import { useState, useCallback } from "react"
import { dataService } from "utils/dataService"

export const useConsent = () => {
  const [consent, setConsent] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const fetchConsent = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const { data } = await dataService.Consent.getAppearanceAnalysisConsent()
      setConsent(data)
      return data
    } catch (err) {
      setError(err)
    } finally {
      setIsLoading(false)
    }
  }, [])

  const upsertConsent = useCallback(async (hasOptedIn) => {
    setIsLoading(true)
    setError(null)
    try {
      await dataService.Consent.setAppearanceAnalysisConsent({ hasOptedIn })
      setConsent(hasOptedIn)
    } catch (err) {
      setError(err)
      throw err
    } finally {
      setIsLoading(false)
    }
  }, [])

  return { consent, isLoading, error, fetchConsent, upsertConsent }
}
